import { AUTH_TOKEN_KEY } from '@/config/app';
import UnauthenticatedError from '@/pages/errors/unauthenticated-error';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(errors)/401')({
  component: UnauthenticatedError,
  beforeLoad: () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);

    if (token) {
      throw redirect({ to: '/' });
    }
  },
});
